import _default from './inlineArrayTransformer';
export { _default as default };
